<template>
  <div class="wechatComplaint div-layout">
    <div class="wechatComplaint-main">
      <div class="wechatComplaint-main-contain">
        <module-title :title="`${isSchool?'校牌':'心电贴'}预约记录`">
          <div class="right">
            <el-button type="primary" size="medium" @click="exportExcel">
              导出
            </el-button>
          </div>
        </module-title>
        <el-form
          ref="searchForm"
          :model="searchForm"
          :inline="true"
          label-position="right"
          label-width="120px"
        >
          <el-form-item label="联系人号码：" prop="phone">
            <el-input
              v-model="searchForm.phone"
              name="phone"
              placeholder="请输入联系人号码"
              class="handle-form-input"
              maxlength="11"
              clearable
              @input="numberInput"
            />
          </el-form-item>
          <el-form-item label="预约领取时间：" prop="time">
            <el-date-picker
              v-model="searchForm.time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="起始时间"
              end-placeholder="截至时间"
              class="handle-form-input"
              @focus="dafaultVulue"
            />
          </el-form-item>
          <el-form-item label="所属区域：" prop="areaCode">
            <el-cascader
              v-model="searchForm.areaCode"
              :options="areaData"
              :props="areaProps"
              class="handle-form-input"
              clearable
              placeholder="选择省/市/区县"
              @change="areaChange"
            />
          </el-form-item>
          <el-form-item label="预约领取街道：" prop="streetId">
            <el-select
              v-model="searchForm.streetId"
              name="streetId"
              size="medium"
              class="handle-form-input"
              @change="fetchCommunitys"
            >
              <el-option label="全部" value="" />
              <el-option
                v-for="item in streetsList"
                :key="item.id"
                :label="item.streetName"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="预约领取社区：" prop="communityId">
            <el-select
              v-model="searchForm.communityId"
              name="communityId"
              size="medium"
              class="handle-form-input"
            >
              <el-option label="全部" value="" />
              <el-option
                v-for="item in communitysList"
                :key="item.id"
                :label="item.communityName"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="medium"
              icon="el-icon-search"
              @click="handleSearchFilter"
            >
              查询
            </el-button>
            <el-button
              size="medium"
              icon="el-icon-refresh-right"
              @click="handleSearchReset"
            >
              重置
            </el-button>
          </el-form-item>
        </el-form>
        <el-table
          v-loading="listLoading"
          :data="dataList"
          highlight-current-row
          fit
          element-loading-text="Loading"
          class="list-table"
        >
          <el-table-column type="index" width="55" align="center" label="序号" />
          <el-table-column label="联系人号码" prop="phone" align="center" />
          <el-table-column label="使用人姓名" prop="name" align="center" />
          <el-table-column label="使用人身份证号" prop="idCard" align="center" />
          <el-table-column v-if="!isSchool" label="领取设备" align="center">
            <template>
              心电贴
            </template>
          </el-table-column>
          <el-table-column label="所属区域" prop="areaName" align="center" />
          <el-table-column label="预约领取街道" prop="streetName" align="center" />
          <el-table-column label="预约领取社区" prop="communityName" align="center" />
          <el-table-column label="领取码" prop="getCode" align="center" width="120">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="bottom" width="160" class="QRcodeImg">
                <QRCodeShowCode :random-time="scope.row.getCode-randomTime" :qr-code-ip="scope.row.getCode" />
                <img v-show="scope.row.getCode" slot="reference" src="@/assets/img/qrcode.svg" alt width="36">
                <p slot="reference">
                  {{ scope.row.getCode }}
                </p>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="预约领取时间" prop="getTime" align="center" />
          <el-table-column label="预约状态" prop="status" align="center" width="100">
            <template slot-scope="scope">
              {{ scope.row.status===1?'已预约':'已取消' }}
            </template>
          </el-table-column>
          <el-table-column label="操作时间" prop="createDate" align="center" />
        </el-table>
        <pagination
          :total="searchForm.total"
          :page.sync="searchForm.pageNum"
          :limit.sync="searchForm.pageSize"
          @pagination="pageCurriculumList"
          @handleSizeChange="handleSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  get_subscribe_pagelist,
  exportSubExcel
} from '@/api/systemMaintenance/devicManage/schoolReserveRecord';
import {
  getStreets,
  getCommunitys
} from '@/api/systemMaintenance/devicManage/cascaderConfig';
import { mapGetters } from 'vuex';
import { getDateTime } from '@/utils/index';
import QRCodeShowCode from '@/components/QRCodeShow/code';
export default {
  name: 'ReserveRecord',
  components: { QRCodeShowCode },
  props: {
    propsData: {
      type: Object,
      default: Object
    }
  },
  data() {
    return {
      areaProps: {
        value: 'code',
        label: 'name',
        children: 'children',
        checkStrictly: true
      },
      ajaxLoading: false,
      isSchool: false,
      // 搜索表单
      searchForm: {
        phone: '',
        subscriStartDate: '',
        subscriEndDate: '',
        time: [],
        areaCode: '',
        provinceId: '',
        cityId: '',
        areaId: '',
        streetId: '',
        communityId: '',
        subscribeType: '', // 预约类型 1-预约校牌 2-预约心电贴
        getCode: '',
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      dateTime: '',
      dataList: [],
      streetsList: [],
      communitysList: [],
      listLoading: false, // 表格刷新loading
      randomTime: 1
    };
  },
  watch: {
    // 路由监听赋值三级菜单
    propsData: {
      handler: function(val, oldVal) {
        this.searchForm.subscribeType = val.subscribeType;
        this.searchForm.getCode = val.getCode ? val.getCode : '';
        this.searchForm.subscribeType === 1 ? this.isSchool = true : this.isSchool = false;
      },
      // $route这个方法之后立即先去执行handler方法
      immediate: true
    }
  },
  computed: {
    ...mapGetters(['areaData'])
  },
  mounted() {
    this.$store.dispatch('getNodes'); // 获取区域
    this.fetchdataList();
    this.randomTime = Math.floor(Math.random() * 10000);
  },
  methods: {
    // 限制input只能输入数字
    numberInput(val) {
      if (val) {
        this.searchForm.phone = val.replace(/[^\d.]/g, '');
      }
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchdataList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchdataList();
    },
    // 条件查询
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.fetchdataList();
    },
    handleSearchReset() {
      this.searchForm = {
        phone: '',
        time: [],
        subscriStartDate: '',
        subscriEndDate: '',
        areaCode: '',
        provinceId: '',
        cityId: '',
        areaId: '',
        streetId: '',
        communityId: '',
        subscribeType: this.propsData.subscribeType, // 预约类型 1-预约校牌 2-预约心电贴
        getCode: '',
        pageNum: 1,
        total: 0,
        pageSize: 10
      };
      this.streetsList = [];
      this.communitysList = [];
      this.fetchdataList();
    },
    areaChange(val) {
      this.searchForm.provinceId = val[0] ? val[0] : '';
      this.searchForm.cityId = val[1] ? val[1] : '';
      this.searchForm.areaId = val[2] ? val[2] : '';
      this.searchForm.streetId = '';
      this.communitysList = [];
      this.searchForm.communityId = '';
      this.fetchStreet();
    },
    dafaultVulue() {
      this.searchForm.time = [getDateTime(-1), getDateTime(-1)];
    },
    fetchStreet() {
      var op = {
        provinceId: this.searchForm.provinceId,
        cityId: this.searchForm.cityId,
        areaId: this.searchForm.areaId
      };
      getStreets(op).then(res => {
        if (res.data && res.data.length > 0) {
          this.streetsList = res.data;
        } else {
          this.streetsList = [];
        }
      }).catch(err => {
        console.log(err);
        this.$message.warning('请求错误');
      });
    },
    fetchCommunitys() {
      var op = {
        streetId: this.searchForm.streetId
      };
      getCommunitys(op).then(res => {
        if (res.data && res.data.length > 0) {
          this.communitysList = res.data;
        } else {
          this.communitysList = [];
        }
      }).catch(err => {
        console.log(err);
        this.$message.warning('请求错误');
      });
    },
    // 导出
    exportExcel() {
      this.getTime();
      var op = {
        phone: this.searchForm.phone,
        subscriStartDate: this.searchForm.subscriStartDate,
        subscriEndDate: this.searchForm.subscriEndDate,
        provinceId: this.searchForm.provinceId,
        cityId: this.searchForm.cityId,
        areaId: this.searchForm.areaId,
        streetId: this.searchForm.streetId,
        communityId: this.searchForm.communityId,
        subscribeType: this.searchForm.subscribeType, // 预约类型 1-预约校牌 2-预约心电贴
        getCode: this.searchForm.getCode,
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize
      };
      window.location.href = exportSubExcel(op);
    },
    getTime() {
      if (this.searchForm.time && this.searchForm.time.length > 0) {
        this.searchForm.subscriStartDate = this.searchForm.time[0];
        this.searchForm.subscriEndDate = this.searchForm.time[1];
      } else {
        this.searchForm.subscriStartDate = '';
        this.searchForm.subscriEndDate = '';
      }
    },
    // 获取应用列表
    fetchdataList() {
      this.listLoading = true;
      this.getTime();
      var op = {
        phone: this.searchForm.phone,
        subscriStartDate: this.searchForm.subscriStartDate,
        subscriEndDate: this.searchForm.subscriEndDate,
        provinceId: this.searchForm.provinceId,
        cityId: this.searchForm.cityId,
        areaId: this.searchForm.areaId,
        streetId: this.searchForm.streetId,
        communityId: this.searchForm.communityId,
        subscribeType: this.searchForm.subscribeType, // 预约类型 1-预约校牌 2-预约心电贴
        getCode: this.searchForm.getCode,
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize
      };
      get_subscribe_pagelist(op)
        .then(result => {
          if (result.data && result.data.list && result.data.list.length) {
            this.dataList = result.data.list;
            this.searchForm.total = result.data.total;
          } else {
            this.dataList = [];
            this.searchForm.total = 0;
          }
          this.listLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.listLoading = false;
          this.dataList = [];
          this.searchForm.total = 0;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.wechatComplaint {
  padding-bottom: 20px;
  .handle-form-input {
    width: 80%;
  }
}
</style>
